import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      region: "eu-west-2",
      userPoolId: "eu-west-2_DDJwm7Qqy",
      userPoolWebClientId: "4bi8nq055s0vrr43s3qc76p8jk",
      oauth: {
        domain: "actadiurna.auth.eu-west-2.amazoncognito.com",
        redirectSignIn: "https://actadiurna.org.uk/",
        redirectSignOut: "https://actadiurna.org.uk/",
        scope: ["openid", "email", "profile"],
        responseType: "token"
      }
    }
  },
  API: {
    REST: {
      userApi: {
        endpoint: "https://mx89tuniqi.execute-api.eu-west-2.amazonaws.com/prod",
        region: "eu-west-2"
      },
      recommendationApi: {
        endpoint: "https://98oi10t0gh.execute-api.eu-west-2.amazonaws.com/prod",
        region: "eu-west-2"
      },
      mediaApi: {
        endpoint: "https://nb40cdxz8a.execute-api.eu-west-2.amazonaws.com/prod",
        region: "eu-west-2"
      }
    }
  },
  Storage: {
    S3: {
      bucket: "acta-diurna-web",
      region: "eu-west-2"
    }
  }
});